export default {
  "title": "FreeDive Ai",
  "heroHeadline": "毎日トレーニングしてフリーダイビングのスキルを向上させましょう！",
  "heroSubheadline": "フリーダイバー、スピアフィッシャー、マーメイドのための究極のAI無呼吸トレーニングアプリ。",
  "featuresHeader": "FreeDive Aiが選ばれる理由",
  "featuresSubtitle": "より深く潜り、より長く息を止め、安全を保つために必要なすべて。",
  "feature1Title": "AI無呼吸トレーニング",
  "feature1Desc": "自己ベストに基づいてAIが生成したカスタムCO2およびO2テーブルで、安全に息止め時間を延ばします。",
  "feature2Title": "スマートログブック",
  "feature2Desc": "フリーダイビングやスピアフィッシングのセッションを記録。深度、時間、心拍数、SpO2をすべて一箇所で追跡。",
  "feature3Title": "大会とライセンス",
  "feature3Desc": "フリーダイビングのライセンスを管理し、世界中の大会やイベントの最新情報を入手できます。",
  "screenshotsTitle": "アプリのスクリーンショット",
  "copyright": "© DomiLabs. All rights reserved."
};
